module.exports = __webpack_public_path__ + "img/shipinghao-l.7ea2e0ed.svg";